import { useRequest } from '@umijs/max';
import type { TablePaginationConfig } from 'antd';
import { message } from 'antd';
import { useEffect, useState } from 'react';

export default (api: any, props: any) => {
  const defaultData = {
    current: 1,
    size: 10,
  };
  const { callback, msg, serchData, isFarstTag = false, debounceInterval = 1000 } = props;
  /* 分页 */
  const [current, setCurrent] = useState<number | undefined>(1);
  const [size, setSize] = useState(props?.size || 10);
  const [isFarst, setIsFarst] = useState(isFarstTag);
  const [total, setTotal] = useState(0);
  /* 查询条件 */
  const [queryData, setQueryData] = useState<any>({
    ...defaultData,
    ...serchData,
  });
  /* 表格状态 */
  const [result, setResult] = useState([]);

  const { loading: Loading, run } = useRequest(api, {
    throttleInterval: 1000,
    debounceInterval,
    manual: true,
    onSuccess: (res) => {
      if (res.status === 0) {
        const { total, records, list } = res.payload;
        setTotal(total);
        setResult(records || list || res.payload);
        if (callback) callback();
        if (msg) message.success(msg);
      }
    },
  });

  const handles = (data?: any) => {
    run({
      ...serchData,
      ...queryData,
      current,
      size,
      pageNum: current,
      pageSize: size,
      ...data,
    });
  };

  /* 通用change方法 */
  const resetPage = (callback?: () => void) => {
    setCurrent(() => {
      return 1;
    });
    setQueryData(() => {
      return { ...defaultData, ...serchData };
    });
    handles();
    if (callback) callback();
  };

  useEffect(() => {
    if (isFarst) {
      handles();
    }
  }, [current, size]);

  useEffect(() => {
    if (isFarst) {
      setCurrent(() => {
        return 1;
      });
      setTotal(() => {
        return 0;
      })
      handles();
    }
    setIsFarst(true);
  }, [queryData]);
  /* 分页 */
  const pageChange = ({ current, pageSize }: TablePaginationConfig) => {
    setCurrent(current);
    setSize(pageSize);
  };

  return {
    Loading,
    queryData,
    setQueryData,
    result,
    total,
    size,
    current,
    resetPage,
    pageChange,
    handles,
    setResult,
  };
};
